import MainTabs from './components/MainTabs'
import Config from './components/Config'

const Configuration = () => {
  return <Config />
}

export default Configuration
